import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartSourceAdjustmentComponent } from '../part-source-adjustment/part-source-adjustment.component';
import { PartSourceAdjustmentAddDialogComponent } from '../part-source-adjustment-add-dialog/part-source-adjustment-add-dialog.component';
import {ReferenceModule} from '../reference.module';



@NgModule({
  declarations: [
    PartSourceAdjustmentComponent,
    PartSourceAdjustmentAddDialogComponent
  ],
  imports: [
    CommonModule,
    ReferenceModule
  ]
})
export class PartSrcAdjModule { }
